exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * To be used with CSS Modules rendered by the webpack.config.\n * Any styles specific to the Sponsor module should live here.\n * Import as neede like so:\n * ...\n * import sponsorStyles from 'sponsorModuleStyles.css';\n * ...\n * render() {\n *   return(\n *     <div styleName=\"sponsor-item\">\n * ...\n */\n\n.modules-sponsor-___sponsorModuleStyles__sponsor-item___1StKm {\n  \n}\n", ""]);

// exports
exports.locals = {
	"sponsor-item": "modules-sponsor-___sponsorModuleStyles__sponsor-item___1StKm"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./modules/sponsor/sponsorModuleStyles.css
// module id = 1360
// module chunks = 1